import LoadNextPost from './LoadNextPost'

export default class {
  constructor() {

    // 投稿の追加読み込み機能
    const domLoadNextPost = document.querySelector('[data-js="story-viewmore-posts"]');
    if (domLoadNextPost) {
      new LoadNextPost(domLoadNextPost);
    }
  }
}
